import { GetState, SetState } from 'zustand';

export interface IAccessTokenSlice {
    accessToken: string;
    isTokenExpired: boolean;
    setAccessToken: (accessToken: string) => void;
    getTokenStatus: (status: boolean) => void;
    setTokenStatus: (status: boolean) => void;
}

const createAccessTokenSlice = (set: SetState<IAccessTokenSlice>, get: GetState<IAccessTokenSlice>) => ({
  accessToken: '',
  isTokenExpired: false,
  setAccessToken: (accessToken: string) => {
    set({ accessToken });
  },
  setTokenStatus: (status: boolean) => {
    set({ isTokenExpired: status });
  },
  getTokenStatus: () => get().isTokenExpired,
});

export default createAccessTokenSlice;
